import React from "react";
import {StyleSheet, View, Text, TouchableOpacity} from "react-native";
import {Color, globalFontStyle} from "../../../assets";
import Colors from "../../../assets/Color/Colors";
import {isMobile, timeLagFromCurrentTime} from "../../../utils/commonMethods";
import {
  market_making_arrow,
  right_arrow,
  tip_image,
} from "../../../utils/images";
import FastImage from "../../../common/FastImage";
import FormTextLabel from "../../../commonComponents/FormTextLabel";
import {
  globalConfigurableData,
  GlobalScreens,
} from "../../../utils/globalConstant";
import withLiveData from "../../../common/withLiveData";

const MarkeMakingCard = props => {
  const {t, live = null, timerExpireCallback = () => {}} = props;

  let yPrice = 0;
  let nPrice = 0;

  yPrice = live?.yCP ?? t?.yCP;
  nPrice = live?.nCP ?? t?.nCP;

  return (
    <View>
      <View
        style={[
          styles.cardContainer,
          GlobalScreens.Home?.mCardBorder
            ? {borderColor: GlobalScreens.Home?.mCardBorder}
            : {},
        ]}>
        <View style={{justifyContent: "space-between"}}>
          <View style={styles.upperRow}>
            <View style={{flex: 5}}>
              <Text
                style={[
                  globalFontStyle.appFontHeading,
                  {
                    color: globalConfigurableData.primaryTextColor1,
                    flexWrap: "wrap",
                    flex: 1,
                  },
                ]}
                numberOfLines={2}>
                {t?.title}
              </Text>
              <Text
                style={[
                  globalFontStyle.appFontBody,
                  {color: globalConfigurableData.secondaryTextColor1},
                ]}
                numberOfLines={1}>
                {t?.subtitle}
              </Text>
            </View>
          </View>

          <View style={styles.bottomRow}>
            <View style={{flexDirection: "row", alignItems: "center", flex: 1}}>
              <View style={{alignItems: "flex-start", flex: 1}}>
                <FormTextLabel
                  labelStyles={[
                    globalFontStyle.appFontSmallText,
                    {
                      color: globalConfigurableData.secondaryTextColor1,
                      paddingBottom: 5,
                    },
                  ]}
                  label={"Price"}
                />
                <View style={[styles.cardBtn]}>
                  <Text
                    style={[
                      globalFontStyle.appFontSubText,
                      {color: globalConfigurableData.primaryTextColor1},
                    ]}>
                    <Text
                      style={[
                        globalFontStyle.appFontSubText,
                        {color: GlobalScreens.Home.yesBtnTxt},
                      ]}>
                      {"Yes " + (yPrice ? yPrice?.toFixed(0) : "-")}
                    </Text>
                    {" | "}
                    <Text
                      style={[
                        globalFontStyle.appFontSubText,
                        {color: GlobalScreens.Home.noBtnTxt},
                      ]}>
                      {"No " + (nPrice ? nPrice?.toFixed(0) : "-")}
                    </Text>
                  </Text>
                </View>
              </View>
              <View style={{alignItems: "flex-start", flex: 1}}>
                <FormTextLabel
                  labelStyles={[
                    globalFontStyle.appFontSmallText,
                    {
                      color: globalConfigurableData.secondaryTextColor1,
                      paddingBottom: 5,
                    },
                  ]}
                  label={"Traders"}
                />
                <View style={[styles.cardBtn]}>
                  <FormTextLabel
                    labelStyles={[
                      globalFontStyle.appFontSubText,
                      {color: globalConfigurableData.primaryTextColor1},
                    ]}
                    label={t?.number_of_traders}
                  />
                </View>
              </View>
              <View style={{alignItems: "flex-start", flex: 1}}>
                <FormTextLabel
                  labelStyles={[
                    globalFontStyle.appFontSmallText,
                    {
                      color: globalConfigurableData.secondaryTextColor1,
                      paddingBottom: 5,
                    },
                  ]}
                  label={"Ticker"}
                />
                <View style={[styles.cardBtn]}>
                  <FormTextLabel
                    labelStyles={[
                      globalFontStyle.appFontSubText,
                      {color: globalConfigurableData.primaryTextColor1},
                    ]}
                    label={t?.range}
                  />
                </View>
              </View>
            </View>
            <FastImage style={{width: 35, height: 35}} source={right_arrow()} />
          </View>
        </View>
        <View style={styles.smileCoinBlk}>
          <Text
            style={[
              globalFontStyle.appFontSmallText,
              {color: globalConfigurableData.globalThemeColor},
            ]}>
            {t?.displayInfo
              ? t?.displayInfo
              : timeLagFromCurrentTime(t?.endsat, true)}
          </Text>
        </View>

        {t?.tooltip !== "" && t?.tooltip && (
          <View style={styles.tipContainer}>
            <FastImage style={styles.volStyle} source={tip_image()} />
            <Text
              style={[
                globalFontStyle.appFontSubText,
                {color: GlobalScreens.Event.tipColor, textAlign: "center"},
              ]}>
              {t?.tooltip}
            </Text>
          </View>
        )}
      </View>
    </View>
  );
};
const getEventId = props => props?.t?.id;
export default withLiveData(getEventId)(MarkeMakingCard);

const styles = StyleSheet.create({
  cardContainer: {
    borderColor: GlobalScreens.Event.borderColor,
    backgroundColor: globalConfigurableData.cardBgColor,
    paddingHorizontal: 15,
    paddingVertical: 18,
    borderRadius: 8,
    borderWidth: 0.75,
    //elevation: 2,
    marginTop: isMobile() ? 15 : 20,
  },
  volStyle: {
    width: 17,
    height: 17,
    marginRight: 5,
  },
  upperRow: {
    flexDirection: "row",
    alignItems: "flex-start",
    marginBottom: 20,
  },
  bottomRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: 5,
  },
  tipContainer: {
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
    backgroundColor: GlobalScreens.Event.tipBackgroundColor,
    paddingVertical: 8,
    paddingHorizontal: 15,
    marginTop: 20,
    marginBottom: -15,
    marginHorizontal: -15,
    flexDirection: "row",
    justifyContent: "center",
  },
  tipTextBlock: {
    borderTopRightRadius: 8,
    borderBottomRightRadius: 8,
    backgroundColor: Colors.bgWhite,
    paddingHorizontal: 6,
    paddingVertical: 2,
    marginRight: 7,
  },
  smileCoinBlk: {
    position: "absolute",
    right: 0,
    top: 0,
    paddingHorizontal: 10,
    paddingVertical: 2,
    backgroundColor: globalConfigurableData.primaryBtnColor,
    borderRadius: 2,
  },
});
